/** Strategem 318 (Venom Cloud): fade-in target art on enemy general(s) */
export const VENOM_CLOUD_TARGET_IMAGE_PATH = '/images/venom_cloud_target.png';
export const VENOM_CLOUD_SOUND_PATH = '/sounds/venom_cloud.mp3';
export const VENOM_CLOUD_TARGET_FADE_DURATION_MS = 720;
